<style>
    .ag-theme-material .ag-cell {
        line-height: 35px !important;
    }
</style>

<template>
  <div id="ag-grid-demo">
    <vx-card class="p-4 mb-6">
        <div class="flex flex-wrap items-center justify-between mb-10">
            <div class="flex items-center">
                <h4 style="margin-left: 10px">Outbound Delivery</h4>
            </div>
            <div class="flex items-center">
                <vs-button @click="refreshData" class="btn mb-4 md:mb-0 mr-1" icon="refresh">Refresh</vs-button>
                <vs-button :to="{ name: 'outbound-add'} " class="btn mb-4 md:mb-0 mr-1" icon="add">Add</vs-button>
                <vs-button :to="{ name: 'outbound-view', params: {id: selectedId} }" class="mb-4 md:mb-0 mr-1" icon="remove_red_eye" :disabled="selectedId ? false : true">View</vs-button>
                <vs-button class="mb-4 md:mb-0 mr-1" @click="removeItem" icon="delete" :disabled="selectedId ? false : true">Delete</vs-button>
                <vs-button class="mb-4 md:mb-0 mr-1" @click="filterInit" icon="filter_list">Filter</vs-button>
                <vs-dropdown>
                    <vs-button class="btn-drop" icon="expand_more">Spreadsheets</vs-button>
                    <vs-dropdown-menu>
                        <vs-dropdown-item @click="downloadTemplate({ type: 'outbound' })">Template</vs-dropdown-item>
                        <vs-dropdown-item @click="showUploadInit">Upload</vs-dropdown-item>
                        <vs-dropdown-item @click="downloadTemplate({ type: 'awb' })">AWB Template</vs-dropdown-item>
                        <vs-dropdown-item @click="$refs.awb_file.click()">Upload AWB</vs-dropdown-item>
                        <vs-dropdown-item @click="exportExcel({ endpoint: 'outbound/outbounddelivery/report/download_excel', filter: filter, name: 'outbound' })">Export</vs-dropdown-item>
                    </vs-dropdown-menu>
                </vs-dropdown>
                <input type="file" ref="outbound_file" style="display: none" v-on:change="uploadFile($event, { endpoint: 'outbound/outbounddelivery/uploadexcel' })" />
                <input type="file" ref="awb_file" style="display: none" v-on:change="uploadFile($event, { endpoint: 'outbound/outbounddelivery/uploadawb' })" />
            </div>
        </div>
        <ag-grid-vue
            :gridOptions="gridOptions"
            class="ag-theme-material w-100 my-4 ag-grid-table"
            :columnDefs="columnDefs"
            :defaultColDef="defaultColDef"
            :rowData="outbounds"
            colResizeDefault="shift"
            :animateRows="false"
            :floatingFilter="false"
            rowSelection="single"
            @selection-changed="onSelectionChanged"
            @rowDoubleClicked="viewData"
            >
        </ag-grid-vue>
        <p class="text-right"><b>Showing {{ dataFrom }} to {{ dataTo }} of {{ dataTotal }}  total entries</b></p>
        <vs-pagination :total="totalPage" v-model="currentPage" :max="7"></vs-pagination>

        <vs-prompt @accept="fetchData" title="Filter" :active.sync="showFilter">
            <div class="con-exemple-prompt">
                <vs-input v-model="filter.outbound_reference" class="mb-2 w-full" label="Reference" />
                <label class="vs-input--label">Client</label>
                <vs-select
                    class="selectExample mb-2"
                    v-model="filter.client_id"
                    width="100%"
                    autocomplete
                    @input-change="searchDropdown($event, ddl_client)"
                >
                    <vs-select-item v-for="(item, index) in ddl_client.data" :key="index" :value="item.id" :text="item.client_code"/>
                </vs-select>

                <label class="vs-input--label">Req. Del. Date</label>
                <vs-row vs-w="12" vs-justify="space-between" class="mb-2">
                    <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="5" style="padding-left: 0">
                        <flat-pickr class="vx-col w-full p-2" v-model="filter.req_del_date_start" />
                    </vs-col>
                    <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="2">To</vs-col>
                    <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="5" style="padding-right: 0">
                        <flat-pickr class="vx-col w-full p-2" v-model="filter.req_del_date_end" />
                    </vs-col>
                </vs-row>

                 <label class="vs-input--label">Origin ID</label>
                <vs-select
                    class="selectExample mb-2"
                    v-model="filter.origin_id"
                    width="100%"
                    autocomplete
                    @input-change="searchDropdown($event, ddl_origin)"
                >
                    <vs-select-item v-for="(item, index) in ddl_origin.data" :key="index" :value="item.id" :text="item.name"/>
                </vs-select>
                
                <label class="vs-input--label">Destination ID</label>
                <vs-select
                    class="selectExample mb-2"
                    v-model="filter.destination_id"
                    width="100%"
                    autocomplete
                    @input-change="searchDropdown($event, ddl_destination)"
                >
                    <vs-select-item v-for="(item, index) in ddl_destination.data" :key="index" :value="item.id" :text="item.name"/>
                </vs-select>
                <label class="vs-input--label">Order Source</label>
                <vs-select
                    class="selectExample mb-2"
                    v-model="filter.order_source_id"
                    width="100%"
                    autocomplete
                >
                    <vs-select-item v-for="(item, index) in order_sources" :key="index" :value="item.id" :text="item.name"/>
                </vs-select>
                <label class="vs-input--label">Status</label>
                <vs-select
                    class="selectExample"
                    v-model="filter.status_id"
                    width="100%"
                    autocomplete
                >
                    <vs-select-item v-for="(item, index) in status" :key="index" :value="item.id" :text="item.name"/>
                </vs-select>
            </div>
        </vs-prompt>

        <vs-prompt @accept="uploadOrder" title="Upload Outbound Delivery" :active.sync="showUpload">
            <div class="con-exemple-prompt">
                <label class="vs-input--label">Order Source</label>
                <vs-select
                    class="selectExample mb-2"
                    v-model="uploadData.order_source"
                    width="100%"
                    autocomplete
                >
                    <vs-select-item v-for="(item, index) in order_sources" :key="index" :value="item.code" :text="item.name"/>
                </vs-select>
                <div v-show="uploadData.order_source !== 'none'">
                    <label class="vs-input--label">Client ID</label>
                    <vs-select
                        class="selectExample mb-2"
                        v-model="uploadData.client_id"
                        width="100%"
                        autocomplete
                        @input-change="searchDropdown($event, ddl_client)"
                    >
                        <vs-select-item v-for="(item, index) in ddl_client.data" :key="index" :value="item.id" :text="item.client_code"/>
                    </vs-select>
                    <label class="vs-input--label">Origin ID</label>
                    <vs-select
                        class="selectExample mb-2"
                        v-model="uploadData.origin_id"
                        width="100%"
                        autocomplete
                        @input-change="searchDropdown($event, ddl_origin)"
                    >
                        <vs-select-item v-for="(item, index) in ddl_origin.data" :key="index" :value="item.id" :text="item.name"/>
                    </vs-select>
                    <label class="vs-input--label">Warehouse ID</label>
                    <vs-select
                        class="selectExample mb-2"
                        v-model="uploadData.warehouse_id"
                        width="100%"
                        autocomplete
                        @input-change="searchDropdown($event, ddl_warehouse)"
                    >
                        <vs-select-item v-for="(item, index) in ddl_warehouse.data" :key="index" :value="item.id" :text="item.warehouses_code"/>
                    </vs-select>
                </div>
                <label class="vs-input--label">File</label>
                <vs-upload
                    :showUploadButton="false"
                    :text="fileName"
                    ref="file_upload" />
            </div>
        </vs-prompt>
    </vx-card>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue"
import '@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

import { saveAs } from "file-saver";

export default {
    components: {
        vSelect,
        AgGridVue,
        flatPickr,
    },
    data() {
        return {
            fileName: "Select file (.xslx, .xls)", 
            showUpload: false,
            searchQuery: '',
            gridOptions: {},
            maxPageNumbers: 7,
            gridApi: null,
            outbounds: [],
            columnDefs: null,
            defaultColDef: {
                sortable: true,
                editable: false,
                resizable: true,
                suppressMenu: true
            },
            selectedId: null,
            isLoading: false,
            maxRetry: 10,
            showFilter: false,
            filter: {
                fetchCount: 0,
                outbound_reference: "",
                client_id: null,
                req_del_date_start: null,
                req_del_date_end: null,
                origin_id:null,
                destination_id:null,
                status_id: 1,
                order_source_id: null
            },
            ddl_client: {
                data: [],
                loading: false,
                endpoint: 'master/clients',
                objectKey: 'client_code'
            },
            ddl_origin: {
                data: [],
                loading: false,
                endpoint: 'master/customers',
                objectKey: 'name'
            },
            ddl_destination: {
                data: [],
                loading: false,
                endpoint: 'master/customers',
                objectKey: 'name'
            },
            ddl_warehouse: {
                data: [],
                loading: false,
                endpoint: 'master/warehouses',
                objectKey: 'warehouses_code'
            },
            uploadData: {
                file: null,
                order_source: 'none',
                client_id: null,
                origin_id: null,
                warehouse_id: null
            },

            status: [],
            
            clientTypeOptions: [],
            areaOptions: [],
            order_sources: [],
            totalPage: 0,
            currentPage: 1,
            dataFrom: 0,
            dataTo: 0,
            dataTotal: 0,
        }
    },
    watch: {
        isLoading: function(){
            if(this.isLoading){
                this.$vs.loading()
            }
            else{
                this.$vs.loading.close()
            }
        },
        currentPage() {
            this.fetchData()
        },
    },
    methods: {
        filterInit() {
            if(this.filter.fetchCount < 1) {
                this.isLoading = true
                this.fetchDropdowns()
                .then(() => {
                    this.isLoading = false
                    this.showFilter = true
                    this.filter.fetchCount++
                })
                .catch(() => {
                    this.isLoading = false
                    this.$vs.dialog({
                        type: "confirm",
                        color: "danger",
                        title: "Server Error",
                        text: "Try again?",
                        accept: () => {
                            this.filterInit();
                        },
                        acceptText: "Yes",
                        cancelText: "No"
                    });
                })
            }
            else {
                this.showFilter = true
            }
        },
        fetchDropdowns() {
            return Promise.all([
                this.$http.post("/master/clients"),
                this.$http.post("/master/customers"),
                this.$http.get("/outbound/outboundstatus"),
                this.$http.get("/master/ordersources"),
            ]).then(
                this.$http.spread((clients, customers, status, order_sources) => {
                    this.ddl_client.data = clients.data.data;
                    this.ddl_origin.data = customers.data.data;
                    this.ddl_destination.data = customers.data.data;
                    this.order_sources = order_sources.data;
                    this.status = status.data
                    this.status.unshift({
                        id: null,
                        name: 'Any'
                    })

                    this.ddl_origin.data.unshift({
                        id: null,
                        name: 'Any'
                    })

                    this.ddl_destination.data.unshift({
                        id: null,
                        name: 'Any'
                    })

                    this.ddl_client.data.unshift({
                        id: null,
                        client_code: 'Any'
                    })

                    this.order_sources.unshift({
                        id: null,
                        name: 'Any'
                    })
                })
            );
        },
        onSelectionChanged() {
            var selectedRows = this.gridApi.getSelectedRows()
            var selectedRowsString = ''
            selectedRows.forEach(function(selectedRow, index) {
                if (index !== 0) {
                selectedRowsString += ', '
                }
                selectedRowsString += selectedRow.id
            })
            this.selectedId = selectedRowsString
        },
        removeItem () {
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: 'Confirm',
                text: 'Are you sure want to delete this outbound?',
                accept: this.acceptAlert
            })
        },
        acceptAlert() {
            this.isLoading = true
            this.$http.delete('outbound/outbounddelivery/' + this.selectedId + '/destroy')
            .then(res => {
                this.$vs.notify({
                    color: 'success',
                    title: 'Outbound delivery deleted',
                    iconPack: 'feather',
                    icon:'icon-check',
                    text: 'The selected outbound delivery was successfully deleted'
                })
                this.fetchData()
            })
            .catch(error => this.handleError(error))
        },
        refreshData() {
            this.maxRetry = 10
            this.fetchData()
        },
        fetchData() {
            this.isLoading = true
            this.setFilter(this.filter);

            Promise.all([this.$http.post('outbound/outbounddelivery?page=' + this.currentPage, this.filter), this.$http.post('unlock_all')])
            .then(this.$http.spread((resp, unlock) => {
                this.outbounds = resp.data.data
                this.totalPage = resp.data.last_page;
                this.dataTotal = resp.data.total;
                this.dataFrom = resp.data.from;
                this.dataTo = resp.data.to;
                this.isLoading = false
            }))
            .catch(resp => {
                this.isLoading = false
                this.$vs.dialog({
                    type: 'confirm',
                    color: 'danger',
                    title: 'Server Error',
                    text: 'Try again?',
                    accept: () => {
                        this.refreshData()
                    },
                    acceptText: 'Yes',
                    cancelText: 'No'
                });
                return;
            })
        },
        viewData() {
            this.$router.push({
                name: 'outbound-view',
                params: {
                    id: this.selectedId
                }
            })
        },
        filterData() {
            this.isLoading = true
            this.$http.post('master/clients/filter/search', this.filter)
            .then(resp => {
                this.clients = resp.data
                this.isLoading = false
            })
        },
        filterActive() {
            this.filter = {
                name: '',
                client_code: '',
                address_1: '',
                address_2: '',
                area_id: '',
                city: '',
                post_code: '',
                clienttype_id: ''
            }
            this.isLoading = true
            Promise.all([this.$http.get('master/areas/filter/getlist'), this.$http.get('master/clienttypes')])
            .then(this.$http.spread((areas, clienttypes) => {
                this.areaOptions = areas.data
                this.clientTypeOptions = clienttypes.data
                this.isLoading = false
                this.showFilter = true
            }))
            .catch(() => {
                this.maxRetry = this.maxRetry - 1
                if(this.maxRetry < 0){
                    this.isLoading = false
                    this.$vs.dialog({
                        type: 'confirm',
                        color: 'danger',
                        title: 'Server Error',
                        text: 'Try again?',
                        accept: () => {
                            this.maxRetry = 10
                            this.filterActive()
                        },
                        acceptText: 'Yes',
                        cancelText: 'No'
                    });
                    return;
                }
                this.filterActive()
            })
        },
        searchArea(search, loading) {
            if(search.length > 2){
                loading(true)
                const data = {
                    name: search
                }
                this.$http.post('master/areas/filter/search', data)
                .then(res => {
                    this.areaOptions = res.data
                    loading(false)
                })
                .catch(() => {
                    this.searchArea(search, loading)
                })
            }
        },
        downloadTemplate({ type }) {
            this.isLoading = true;
            const endpoint = type == 'outbound' ? 'outbound/outbounddelivery/report/get_template' : 'outbound/outbounddelivery/report/getawbtemplate'
            this.$http
                .get(endpoint, { responseType: "blob" })
                .then(response => {
                    var blob = new Blob([response.data]);
                    saveAs(blob, `${type}_template_${Date.now()}.xlsx`);
                    this.isLoading = false;
                });
        },
        uploadFile(event, { endpoint }) {
            let formData = new FormData();
            formData.append("file", event.target.files[0]);
            this.isLoading = true;
            this.$http.post(endpoint, formData, {
                headers: {
                    "Content-Type": "multipart/form-data"
                }
            })
            .then(resp => {
                this.isLoading = false;
                const message = resp.data.message || 'Upload success.'
                this.fetchData();
                this.$vs.notify({
                    color: "success",
                    title: "Success",
                    text: message
                });
            })
            .catch(error => this.handleError(error))
        },
        uploadOrder() {
            this.isLoading = true;

            let formData = new FormData();
            formData.append("file", this.uploadData.file);

            this.$http.post('outbound/outbounddelivery/uploadexcel', formData, {
                headers: {
                    "Content-Type": "multipart/form-data"
                },
                params: {
                    "source": this.uploadData.order_source,
                    "origin_id": this.uploadData.origin_id,
                    "client_id": this.uploadData.client_id,
                    "warehouse_id": this.uploadData.warehouse_id,
                }
            })
            .then(async resp => {
                if (resp.data.errors_filename) {
                    const endpoint = 'outbound/outbounddelivery/download_errors';

                    await this.$http
                        .post(endpoint, {filename: resp.data.errors_filename}, { responseType: "blob" })
                        .then(async response => {
                            var blob = new Blob([response.data]);
                            await saveAs(blob, `upload_errors_${Date.now()}.xlsx`);
                        });
                }

                this.isLoading = false;
                const message = resp.data.message || 'Upload success.'
                this.fetchData();
                this.$vs.notify({
                    color: "success",
                    title: "Success",
                    text: message
                });
            })
            .catch(error => this.handleError(error))
        },
        resetUploadForm() {
            this.uploadData.order_source = "none";
            this.uploadData.client_id = this.getUserDefault('client_id');
            this.uploadData.warehouse_id = this.getUserDefault('warehouse_id');
            this.uploadData.origin_id = this.getUserDefault('origin_id');
            this.fileName = "Select file (.xslx, .xls)";
        },
        showUploadInit() {
            this.isLoading = true;
            this.uploadData.file = null;

            Promise.all([
                this.$http.get('master/ordersources'),
                this.$http.post('master/clients'),
                this.$http.post('master/warehouses'),
                this.$http.post('master/customers')
            ])
            .then(this.$http.spread((order_sources, clients, warehouses, customers) => {
                this.resetUploadForm();
                this.order_sources = order_sources.data;
                this.ddl_client.data = clients.data.data;
                this.ddl_origin.data = customers.data.data;
                this.ddl_warehouse.data = warehouses.data.data;

                this.order_sources.unshift({
                    code: 'none',
                    name: 'None (WMS Template)'
                });

                this.showUpload = true;
                setTimeout(() => {
                    this.$watch(() => {
                        return this.$refs.file_upload.filesx[0];
                    }, val => {
                        this.getSelectedFile();
                    });
    
                    this.isLoading = false;
                }, 100);
            }))
            .catch(error => this.handleError(error));
        },
        getSelectedFile() {
            const files = this.$refs.file_upload.filesx;

            if(files.length > 1) {
                files.splice(0, 1);
            }

            const file = files[0];

            if(file) {
                const filetype = file.type;
                if(filetype !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' && filetype !== 'application/vnd.ms-excel') {
                    files.splice(0, 1);
                    this.uploadData.file = null;

                    this.$vs.notify({
                        color: 'danger',
                        title: 'Error',
                        iconPack: 'feather',
                        icon:'icon-x',
                        text: 'Invalid file format',
                    })
                }
                else {
                    this.uploadData.file = file;
                    this.fileName = file.name;
                }
            }
        }
    },
    mounted() {
        this.fetchData()
        this.gridApi = this.gridOptions.api;
    },
    beforeMount() {
        const filter = this.getFilter();

        if(filter) {
            this.filter = filter
            this.filter.fetchCount = 0;
        }

        this.columnDefs = [
            {
                headerName: 'ID',
                field: 'id',
                width: 120,
                filter: true,
            },
            {
                headerName: 'Client ID',
                field: 'client.client_code',
                width: 120,
                filter: true,
                // checkboxSelection: true,
                // headerCheckboxSelectionFilteredOnly: true,
                // headerCheckboxSelection: true,
            },
            {
                headerName: 'Reference',
                field: 'outbound_reference',
                filter: true,
                width: 120,
            },
            {
                headerName: 'Req. Del. Date',
                field: 'req_del_date',
                filter: true,
                width: 120,
                // pinned: 'left'
            },
            {
                headerName: 'Origin',
                field: 'origin.name',
                filter: true,
                width: 120,
            },
            {
                headerName: 'Destination',
                field: 'destination.name',
                filter: true,
                width: 120,
            },
            {
                headerName: 'Order Source',
                field: 'order_source.name',
                filter: true,
                width: 120,
            },
            {
                headerName: 'Status',
                field: 'status.name',
                filter: true,
                width: 120,
            },
            {
                headerName: 'Upload/Input Date',
                field: 'created_at',
                filter: true,
                width: 120,
            },
        ];

        this.gridOptions.getRowHeight = function(params) {
            return 35;
        }
    }
}

</script>